import { defaultHttpClient } from '../../httpClient';
import type { GetOverviewResponse } from './types';

/**
 * - 웹뷰 오버뷰 카테고리 조회 API
 */
export const getOverview = (type: string) => {
  return defaultHttpClient
    .request<GetOverviewResponse>({
      method: 'GET',
      url: `/webview/overview/${type}`,
    })
    .then(r => r.data);
};
